import { useTranslation } from 'react-i18next';
import './style.css';

const BiometricInfo = ({ data }) => {
    const { t } = useTranslation();
    
    return (
        <div className="patient-biometric-info-section">
            <div className="patient-biometric-info-header">
                <div className="patient-biometric-info-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <h3 className="patient-biometric-info-title">{t('biometric-lifestyle-info')}</h3>
            </div>
            <div className="patient-biometric-info-grid">
                <div className="patient-biometric-info-item">
                    <div className="patient-biometric-info-item-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="patient-biometric-info-item-content">
                        <span className="patient-biometric-info-item-label">{t('height').toUpperCase()}</span>
                        <p className="patient-biometric-info-item-value">{data?.height || '182 cm'}</p>
                    </div>
                </div>

                <div className="patient-biometric-info-item">
                    <div className="patient-biometric-info-item-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2v20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="patient-biometric-info-item-content">
                        <span className="patient-biometric-info-item-label">{t('weight').toUpperCase()}</span>
                        <p className="patient-biometric-info-item-value">{data?.weight || '84 Kg'}</p>
                    </div>
                </div>

                <div className="patient-biometric-info-item">
                    <div className="patient-biometric-info-item-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="patient-biometric-info-item-content">
                        <span className="patient-biometric-info-item-label">{t('marital-status').toUpperCase()}</span>
                        <p className="patient-biometric-info-item-value">{!data?.maritalStatus ? t('Single') : t('Married')}</p>
                    </div>
                </div>

                <div className="patient-biometric-info-item">
                    <div className="patient-biometric-info-item-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 8h1a4 4 0 0 1 0 8h-1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <line x1="6" y1="1" x2="6" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <line x1="10" y1="1" x2="10" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <line x1="14" y1="1" x2="14" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="patient-biometric-info-item-content">
                        <span className="patient-biometric-info-item-label">{t('smoking-status').toUpperCase()}</span>
                        <p className="patient-biometric-info-item-value">{!data?.isSmoker ? t('Non-Smoker') : t('Smoker')}</p>
                    </div>
                </div>

                <div className="patient-biometric-info-item">
                    <div className="patient-biometric-info-item-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="patient-biometric-info-item-content">
                        <span className="patient-biometric-info-item-label">{t('alcohol-status').toUpperCase()}</span>
                        <p className="patient-biometric-info-item-value">{data?.isDrinkAlcohol ? t('Drink') : t('Never')}</p>
                    </div>
                </div>

                <div className="patient-biometric-info-item">
                    <div className="patient-biometric-info-item-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="patient-biometric-info-item-content">
                        <span className="patient-biometric-info-item-label">{t('prev-operations').toUpperCase()}</span>
                        <p className="patient-biometric-info-item-value">{data?.medicalOperation }</p>
                    </div>
                </div>

                <div className="patient-biometric-info-item">
                    <div className="patient-biometric-info-item-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="patient-biometric-info-item-content">
                        <span className="patient-biometric-info-item-label">{t('allergies').toUpperCase()}</span>
                        <p className="patient-biometric-info-item-value patient-biometric-info-item-value-alert">{data?.allergy }</p>
                    </div>
                </div>

                <div className="patient-biometric-info-item">
                    <div className="patient-biometric-info-item-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <line x1="12" y1="18" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <line x1="9" y1="15" x2="15" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="patient-biometric-info-item-content">
                        <span className="patient-biometric-info-item-label">{t('medication').toUpperCase()}</span>
                        <p className="patient-biometric-info-item-value">{data?.regularMedicationName}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BiometricInfo;

